import React from "react";
import { PageHero } from "../components/Shared";
import { Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Lettre() {
  return (
    <div className="bg-[#FDFBF7] min-h-screen">
      <PageHero
        label="Sénatoriales 2026 · Haut-Rhin"
        title="Lettre de candidature"
        subtitle="Notre lettre aux Grands Électeurs du Haut-Rhin — document officiel"
      />
      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
        <div className="text-center mb-10">
          <a
            href={`${API}/api/tract-a4-essai-33.pdf`}
            target="_blank"
            rel="noreferrer"
            data-testid="lettre-download-tract"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#12495B] text-[#F5C518] font-extrabold uppercase tracking-wide hover:bg-[#0E3A49] transition-colors duration-300"
          >
            <Download size={18} /> Télécharger le document (PDF)
          </a>
        </div>
        <div data-testid="lettre-content" className="space-y-10">
          <img
            src={`${API}/api/static/lettre-page1.png`}
            alt="Lettre de candidature — page 1"
            data-testid="lettre-page-1"
            className="w-full rounded-xl shadow-[0_15px_45px_rgb(0,0,0,0.15)] border border-slate-200"
          />
          <img
            src={`${API}/api/static/lettre-page2.png`}
            alt="Lettre de candidature — page 2"
            data-testid="lettre-page-2"
            className="w-full rounded-xl shadow-[0_15px_45px_rgb(0,0,0,0.15)] border border-slate-200"
          />
        </div>
      </section>
    </div>
  );
}
